/**
 * Deterministic stock room image based on room-name keyword.
 * Used as a fallback when hotel admin hasn't uploaded a room photo yet.
 *
 * Stock images sourced from Unsplash (CC0 license, no attribution required).
 */

const ROOM_IMAGES = {
  // ORDER MATTERS — longer/more specific keywords FIRST
  heritage:  'https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=800',
  executive: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800',
  premium:   'https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=800',
  deluxe:    'https://images.unsplash.com/photo-1590490360182-c33d57733427?w=800',
  standard:  'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=800',
  budget:    'https://images.unsplash.com/photo-1631049035326-57414e7739c2?w=800',
  family:    'https://images.unsplash.com/photo-1566665797739-1674de7a421a?w=800',
  villa:     'https://images.unsplash.com/photo-1582719508461-905c673771fd?w=800',
  twin:      'https://images.unsplash.com/photo-1540518614846-7eded433c457?w=800',
  king:      'https://images.unsplash.com/photo-1631049552240-59c37f38802b?w=800',
  queen:     'https://images.unsplash.com/photo-1551776235-dde6d4829808?w=800',
  bunk:      'https://images.unsplash.com/photo-1555854877-bab0e564b8d5?w=800',
  dorm:      'https://images.unsplash.com/photo-1555854877-bab0e564b8d5?w=800',
  suite:     'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800',
};

const FALLBACK_ROOM_IMG = 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800';

/**
 * Choose the best stock photo for a given room.
 * Priority:
 *  1. Explicit `room.images[0]` (if hotel uploaded one)
 *  2. Explicit `room.image`
 *  3. Keyword match in `room.name` (case-insensitive) against ROOM_IMAGES
 *  4. Hotel's own first photo as a last resort
 *  5. Hard-coded fallback
 */
export const roomImageFor = (room, hotel) => {
  if (Array.isArray(room?.images) && room.images[0]) return room.images[0];
  if (room?.image) return room.image;
  const name = String(room?.name || '').toLowerCase();
  for (const key of Object.keys(ROOM_IMAGES)) {
    if (name.includes(key)) return ROOM_IMAGES[key];
  }
  if (Array.isArray(hotel?.images) && hotel.images[0]) return hotel.images[0];
  return FALLBACK_ROOM_IMG;
};
